export default __webpack_public_path__ + "static/media/MacRA-Design_ICONE_Channel-and-bank-protection.489ee273.jpg";